import React from 'react'
import { FirebaseApp } from 'firebase/app'
import { CollectionReference, DocumentData, Firestore } from 'firebase/firestore'
import { Auth } from 'firebase/auth'
import { FirebaseStorage } from 'firebase/storage'

import { Candidate } from '../../types'

type FirestoreContextValue = {
  app: FirebaseApp
  firestore: Firestore
  auth: Auth
  storage: FirebaseStorage
  candidateCollection: CollectionReference<Candidate, DocumentData>
}

export const FirebaseContext = React.createContext<FirestoreContextValue>(undefined!)
